import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { Box, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import axios from 'axios';
import envConfig from "../../../bin/env.config";
import { useSelector } from "react-redux";
import { STATUS_OPTIONS, BACKGROUND_STATUS_COLORS } from '../../../utility/statusConfig';

export default function ProductStatusByCityChart({user_type_id, selectedCity, selectedBanners }) {
  const token = useSelector((state) => state.session.token);
  const [cities, setCities] = useState([]);
  const [selectedCityFilter, setSelectedCityFilter] = useState('All Cities');
  const [statuses, setStatuses] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: []
  });

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
      title: {
        display: true,
        text: 'Product Status Distribution by City',
        font: { size: 18 },
        padding: { bottom: 10 }
      },
      tooltip: { enabled: true },
    },
    interaction: {
      intersect: false,
    },
    maintainAspectRatio: false,
    scales: {
      x: {
        title: {
          display: true,
          text: 'City',
          font: { size: 14 },
        },
        ticks: {
          callback: function(value, index) {
            return this.getLabelForValue(value);
          },
          maxRotation: 45,
          minRotation: 45,
          autoSkip: false,
          font: { size: 12 }
        },
      },
      y: {
        beginAtZero: true,
        display: true,
        title: {
          display: true,
          text: 'Number of Products',
          font: { size: 14 },
        },
        grid: { color: '#eee' },
        ticks: {
          font: { size: 12 }
        }
      },
    },
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/data-freshness-reporting/product-status-distribution-by-city`,
          {
            user_type_id: user_type_id,
            city: selectedCity,
            banners: selectedBanners
          },
          {
            headers: {
              Authorization: token,
            },
          }
        );
        const data = response.data.data;        
        // Process data to group by city and status
        const tempCities = [...new Set(data.map(item => item.city))];
        const tempStatuses = Object.keys(STATUS_OPTIONS).map(key => parseInt(key));
        setCities(tempCities);
        setStatuses(tempStatuses);
        setDataSource(data);        
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [selectedCity, selectedBanners]);

  useEffect(() => {
    const fetchChartData =() => {
      try {
        const data = selectedCityFilter=='All Cities'?dataSource:dataSource.filter(item => item.city === selectedCityFilter);
        const selectedCities = selectedCityFilter=='All Cities'?cities:[selectedCityFilter];
        // Create datasets for each status
        const datasets = statuses.map((status, index) => {
          const statusData = selectedCities.map(city => {
            const item = data.find(d => d.city === city && d.status_id === status);
            return item ? parseInt(item.product_count) : 0;
          });
          
          return {
            label: STATUS_OPTIONS[status] || `Status ${status}`,
            data: statusData,
            backgroundColor: BACKGROUND_STATUS_COLORS[status] || '#9E9E9E',
            borderRadius: 4,
            barPercentage: 0.7,
            categoryPercentage: 0.7,
          };
        });
        setChartData({
          labels: selectedCities,
          datasets: datasets
        });
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    
    dataSource.length>0&&fetchChartData();
  }, [selectedCityFilter, dataSource]);
  return (
    <>
      <Box sx={{ mb: 2 }}>
        <FormControl fullWidth>
          {/* <InputLabel id="city-filter-label">Filter by City</InputLabel> */}
          <Select
            // labelId="city-filter-label"
            id="city-filter"
            value={selectedCityFilter}
            label="Filter by City"
            onChange={(e) => setSelectedCityFilter(e.target.value)}
          >
            <MenuItem value="All Cities">All Cities</MenuItem>
            {cities.map((city) => (
              <MenuItem key={city} value={city}>
                {city}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Box sx={{ height: 'calc(100vh - 200px)', minHeight: '400px', maxHeight: '600px' }}>
        <Bar data={chartData} options={options} />
      </Box>
    </>
  );
} 